<script setup>
import { TabsList } from 'radix-vue'
import { cn } from '@/lib/utils'

const props = defineProps({
  loop: { type: Boolean, required: false },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  class: { type: null, required: false },
})
</script>

<template>
  <TabsList
    v-bind="props"
    :class="
      cn(
        'inline-flex h-10 items-center justify-center rounded-md bg-surface-2 p-1 text-muted',
        props.class,
      )
    "
  >
    <slot />
  </TabsList>
</template>
